import styled from 'styled-components';
import theme from '../../../theme';

const Container = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;

    > div {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        height: calc(100vh - 40px);
    }

    img {
        margin-bottom: 20px;
        max-width: calc(100% - 140px);
    }

    span {
        margin: auto 0 20px 0;
        font-size: 14px;
        font-weight: 400;
        color: #1F1F1F;

        a {
            margin-left: 5px;
            color: ${theme.primaryColor};
        }
    }
`;

const Content = styled.div`
    background-color: ${theme.white};
    width: calc(100% - 80px);
`;

export { Container, Content };